export interface LogChange {
  id: number;
  oldValue: string | null;
  newValue: string | null;
  removedValueArray: string[] | null;
  addedValueArray: string[] | null;
  isArray: boolean;
  paramName: string;
  label: string;
  table: string | null;
}

export interface LogUser {
  firstName: string;
  lastName: string;
}

export interface LogEntry {
  id: number;
  date: string | Date;
  action: string;
  changes: LogChange[];
  user: LogUser;
}

export interface LogData {
  id: number;
  type: string;
  sourceId: string;
  logs: LogEntry[];
}



export enum CoreLogTypeEnum {
  case = 'case',
}
